<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">{{trans('user.user')}} 
               <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
              <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="questionnaire" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9 pta-content-quest">
                                  <button class="btn btn-info btn-sm pull-right" @click="getAIData"><i class="icon-13"></i> <span class="d-none d-sm-inline">AI Generation</span></button>
                                    <h4 class="card-title">Questionnaire</h4>

                                    <form @submit.prevent="submit" @keydown="questionaireForm.errors.clear($event.target.name)">
                                      <div class="pta-steps" style="margin-bottom:30px;">
                                        <h3>PERSONAL DETAILS:</h3>
                                        <label>Your Company’s Name</label>
                                        <input  type="text" class="pta-form-text" v-model="questionaireForm.company" style="margin-bottom:0;" />
                                        <show-error :form-name="questionaireForm" prop-name="company"></show-error>
                                        <label style="padding-top:20px;">Your Work Phone Number</label>
                                        <input  type="text" class="pta-form-text" v-model="questionaireForm.phone" style="margin-bottom:0;" />
                                        <span style="display:block;padding-top:5px;font-size:14px;color:#999;">Please also add your country code.</span>
                                        <show-error :form-name="questionaireForm" prop-name="phone"></show-error>
                                        <label style="padding-top:20px;">Where are your company's headquarters?</label>
                                        <v-select label="name" track-by="id" v-model="selected_hq_countries" name="hq_country_id" id="hq_country_id" :options="countries" :placeholder="'Please choose'" @select="onHQCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onHQCountryRemove" :selected="selected_hq_countries"></v-select>
                                        <span style="display:block;padding-top:5px;font-size:14px;color:#999;">Start typing your country name in the box and press "choose" to select.</span>
                                        <show-error :form-name="questionaireForm" prop-name="hq_country_id"></show-error>

                                        <label style="padding-top:20px;">General description of your company <span>(Optional)</span></label>
                                        <autosize-textarea placeholder="" v-model="questionaireForm.company_description" rows="2" name="company_description"></autosize-textarea>
                                        <show-error :form-name="questionaireForm" prop-name="company_description"></show-error>
                                        <!-- <button type="submit" class="btn btn-info waves-effect waves-light m-t-10 pull-right">{{trans('general.save')}}</button> -->
                                        <div class="pta-steps" style="margin-bottom:10px;padding-top:50px;">
                                          <h3>ABOUT YOUR FUND / DEAL:</h3>
                                          <label>In which Asset Class are you investing?</label>
                                          <select @change="getFundTypes" v-model="questionaireForm.fund_category_id" id="continent_2_id" class="custom-select">
                                            <option value="">Please choose the fund category</option>
                                            <option v-for="fund_category in fund_categories" v-bind:value="fund_category.id">
                                              {{ fund_category.name }}
                                            </option>
                                          </select>
                                          <show-error :form-name="questionaireForm" prop-name="fund_category_id"></show-error>
                                          <select v-model="questionaireForm.fund_type_id" id="fund_type_id" class="custom-select" v-if="fund_types_cur && questionaireForm.fund_category_id" style="margin-top:10px;">
                                            <option value="">Please choose the fund type</option>
                                            <option v-for="fund_type in fund_types_cur" v-bind:value="fund_type.id">
                                              {{ fund_type.name }}
                                            </option>
                                          </select>
                                          <show-error :form-name="questionaireForm" prop-name="fund_type_id" v-if="questionaireForm.fund_category_id"></show-error>
                                          <div>
                                            <label style="padding-top:30px;">Where are you investing primarily?</label>
                                            <v-select label="name" track-by="id" v-model="selected_asset_countries" name="asset_country_id" id="asset_country_id" :options="countries" :placeholder="'Please choose'" @select="onAssetCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onAssetCountryRemove" :selected="selected_asset_countries"></v-select>
                                            <show-error :form-name="questionaireForm" prop-name="asset_country_id"></show-error>

                                            <label style="padding-top:30px;">In what Country is your investment vehicle domiciled?</label>
                                            <v-select label="name" track-by="id" v-model="iv_country_id" name="iv_country_id" id="iv_country_id" :options="countries" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                            <show-error :form-name="questionaireForm" prop-name="iv_country_id"></show-error>

                                            <label style="padding-top:30px;">What is the investment vehicle's currency?</label>
                                            <v-select label="name" track-by="id" v-model="currency_id" name="currency_id" id="currency_id" :options="currencies" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                            <show-error :form-name="questionaireForm" prop-name="currency_id"></show-error>

                                            <label style="padding-top:30px;">What is the expected holding period (in years)?</label>
                                            <select v-model="questionaireForm.holding_period" id="holding_period" class="custom-select">
                                              <option value="0">Please choose</option>
                                              <option v-for="index in 30" v-bind:value="index">
                                                {{ index }}
                                              </option>
                                            </select>
                                            <show-error :form-name="questionaireForm" prop-name="holding_period"></show-error>

                                            <label style="padding-top:30px;">Are you a member of any ESG associations?</label>
                                            <ul style="margin-bottom:0;">
                                              <li><input type="radio" id="esg_yes" name="esg" value="Yes" v-model="questionaireForm.esg" /><label for="esg_yes">Yes</label></li>
                                              <li><input type="radio" id="esg_no" name="esg" value="No" v-model="questionaireForm.esg" /><label for="esg_no">No</label></li>
                                            </ul>
                                            <show-error :form-name="questionaireForm" prop-name="esg"></show-error>

                                            <label style="padding-top:30px;">What is your Investment Structure?</label>
                                            <ul style="margin-bottom:0;">
                                              <li><input type="radio" id="inv_struct_direct_deal" name="inv_struct" value="Direct Deal Investment" v-model="questionaireForm.inv_struct" /><label for="inv_struct_direct_deal">Direct Deal Investment</label></li>
                                              <li><input type="radio" id="inv_struct_fund" name="inv_struct" value="Fund Investment" v-model="questionaireForm.inv_struct" /><label for="inv_struct_fund">Fund Investment</label></li>
                                            </ul>
                                            <show-error :form-name="questionaireForm" prop-name="inv_struct"></show-error>

                                            <label style="padding-top:30px;">What is the total capital raising target for your offering (In USD Millions)?</label>
                                            <input  type="text" class="pta-form-text" v-model="questionaireForm.total_capital" style="margin-bottom:0;" @keypress="onlyAmount" />
                                            <show-error :form-name="questionaireForm" prop-name="total_capital"></show-error>

                                            <label style="padding-top:30px;">What is your target gross return (IRR %)?</label>
                                            <input  type="text" class="pta-form-text" v-model="questionaireForm.irr" style="margin-bottom:0;" @keypress="onlyAmount" />
                                            <show-error :form-name="questionaireForm" prop-name="irr"></show-error>

                                            <label style="padding-top:30px;">What is your target gross Equity Multiple / MOIC (x)?</label>
                                            <input  type="text" class="pta-form-text" v-model="questionaireForm.moic" style="margin-bottom:0;" @keypress="onlyAmount" />
                                            <show-error :form-name="questionaireForm" prop-name="moic"></show-error>

                                            <label style="padding-top:30px;">What is the minimum investment ticket size acceptable (In USD Millions)?</label>
                                            <input  type="text" class="pta-form-text" v-model="questionaireForm.ticket_size" style="margin-bottom:0;" @keypress="onlyAmount" />
                                            <show-error :form-name="questionaireForm" prop-name="ticket_size"></show-error>

                                            <label style="padding-top:30px;">Describe your investment strategy</label>
                                            <autosize-textarea  placeholder="Example: Providing bridge and mezzanine loans for middle-market companies across the UK." v-model="questionaireForm.strategy" rows="2" name="strategy"></autosize-textarea>
                                            <show-error :form-name="questionaireForm" prop-name="strategy"></show-error>

                                            <div v-if="questionaireForm.inv_struct=='Fund Investment'">
                                              <label style="padding-top:30px;">What is your fund status?</label>
                                              <ul style="margin-bottom:0;">
                                                <li><input type="radio" id="fund_status_yes" name="fund_status" value="Closed Ended" v-model="questionaireForm.fund_status" /><label for="fund_status_yes">Closed Ended</label></li>
                                                <li><input type="radio" id="fund_status_no" name="fund_status" value="Open Ended" v-model="questionaireForm.fund_status" /><label for="fund_status_no">Open Ended</label></li>
                                              </ul>
                                              <show-error :form-name="questionaireForm" prop-name="fund_status"></show-error>
                                              <label style="padding-top:30px;">Is this a first time fund?</label>
                                              <ul style="margin-bottom:0;">
                                                <li><input type="radio" id="fund_first_time_yes" name="fund_first_time" value="Yes" v-model="questionaireForm.fund_first_time" /><label for="fund_first_time_yes">Yes</label></li>
                                                <li><input type="radio" id="fund_first_time_no" name="fund_first_time" value="No" v-model="questionaireForm.fund_first_time" /><label for="fund_first_time_no">No</label></li>
                                              </ul>
                                              <show-error :form-name="questionaireForm" prop-name="fund_first_time"></show-error>
                                              <label style="padding-top:30px;">Expected Timing of First Close</label>
                                              <VueCtkDateTimePicker v-model="questionaireForm.fund_first_close" format="YYYY-MM-DD" :no-label="true" :no-header="false" formatted="DD.MM.YYYY" color="#20365F" :only-date="true" label="none" button-now-translation="today" />
                                              <show-error :form-name="questionaireForm" prop-name="fund_first_close"></show-error>
                                              <label style="padding-top:30px;">Expected Timing of Final Close</label>
                                              <VueCtkDateTimePicker :minDate="questionaireForm.fund_first_close" v-model="questionaireForm.fund_final_close" format="YYYY-MM-DD" :no-label="true" :no-header="false" formatted="DD.MM.YYYY" color="#20365F" :only-date="true" label="none" button-now-translation="today" /> <!--  :disabled-weekly="[0,6]" -->
                                              <show-error :form-name="questionaireForm" prop-name="fund_final_close"></show-error>
                                              <label style="padding-top:30px;">Could you please provide us with the specific name of the product, or financial vehicle for which you are currently raising capital for? For instance, ‘Alpha Partners Fund III’?</label>
                                              <input type="text" class="pta-form-text" v-model="questionaireForm.product_name" style="margin-bottom:0;" />
                                              <show-error :form-name="questionaireForm" prop-name="product_name"></show-error>
                                            </div>

                                            <div>
                                              <h3 style="padding-top:30px;">ABOUT YOUR TRACK RECORD:</h3>
                                              <label>Could you briefly outline four of your key track record highlights?</label>
                                              <autosize-textarea  :style="'margin-bottom:10px;'" v-model="questionaireForm.track_record_1" rows="2" name="track_record_1" :placeholder="'Example: Any key differentiators of your offering relative to managers in your industry.'"></autosize-textarea>
                                              <show-error :style="'margin-top:-10px;margin-bottom:10px;'" :form-name="questionaireForm" prop-name="track_record_1"></show-error>
                                              <autosize-textarea  :style="'margin-bottom:10px;'" v-model="questionaireForm.track_record_2" rows="2" name="track_record_2" :placeholder="'Example: IRR delivered in previous funds/deals.'"></autosize-textarea>
                                              <show-error :style="'margin-top:-10px;margin-bottom:10px;'" :form-name="questionaireForm" prop-name="track_record_2"></show-error>
                                              <autosize-textarea  :style="'margin-bottom:10px;'" v-model="questionaireForm.track_record_3" rows="2" name="track_record_3" :placeholder="'Example: Your team\'s experience in the industry.'"></autosize-textarea>
                                              <show-error :style="'margin-top:-10px;margin-bottom:10px;'" :form-name="questionaireForm" prop-name="track_record_3"></show-error>
                                              <autosize-textarea  :style="'margin-bottom:10px;'" v-model="questionaireForm.track_record_4" rows="2" name="track_record_4" :placeholder="'Example: Total amount of capital that you\'ve raised so far.'"></autosize-textarea>
                                              <show-error :style="'margin-top:-10px;margin-bottom:0px;'" :form-name="questionaireForm" prop-name="track_record_4"></show-error>


                                              <h3 style="padding-top:30px;">INVESTMENTS:</h3>
                                              <label>Describe your investment thesis and rationale.</label>
                                              <autosize-textarea placeholder="" v-model="questionaireForm.investment_thesis" rows="2" name="investment_thesis"></autosize-textarea>
                                              <show-error :form-name="questionaireForm" prop-name="investment_thesis"></show-error>

                                              <label style="padding-top:30px;">In which sub-sectors are you investing in (for instance, for private equity this could be TMT or ClimateTech. For real estate strategies, this could be multi-family homes)?</label>
                                              <autosize-textarea placeholder="" v-model="questionaireForm.investment_focus_subsectors" rows="2" name="investment_focus_subsectors"></autosize-textarea>
                                              <show-error :form-name="questionaireForm" prop-name="investment_focus_subsectors"></show-error>

                                              <label style="padding-top:30px;">Describe your investment criteria and selection process.</label>
                                              <autosize-textarea placeholder="" v-model="questionaireForm.investment_criteria" rows="2" name="investment_criteria"></autosize-textarea>
                                              <show-error :form-name="questionaireForm" prop-name="investment_criteria"></show-error>

                                              <h3 style="padding-top:50px;">TERMS:</h3>
                                              <label>Can you describe the proceeds distribution policy?</label>
                                              <autosize-textarea placeholder="" v-model="questionaireForm.terms_policies" rows="2" name="terms_policies"></autosize-textarea>
                                              <show-error :form-name="questionaireForm" prop-name="terms_policies"></show-error>

                                              <label style="padding-top:30px;">Describe the lock-up periods applicable (if any).</label>
                                              <autosize-textarea placeholder="" v-model="questionaireForm.terms_lockup_period" rows="2" name="terms_lockup_period"></autosize-textarea>
                                              <show-error :form-name="questionaireForm" prop-name="terms_lockup_period"></show-error>

                                              <label style="padding-top:30px;">How much is the management fee charged (%)?</label>
                                              <input type="text" class="pta-form-text" v-model="questionaireForm.terms_management_fee" style="margin-bottom:0;" />
                                              <show-error :form-name="questionaireForm" prop-name="terms_management_fee"></show-error>

                                              <label style="padding-top:30px;">How much is the amount of carried interest charged (%)?</label>
                                              <input type="text" class="pta-form-text" v-model="questionaireForm.terms_performance_fee" style="margin-bottom:0;" />
                                              <show-error :form-name="questionaireForm" prop-name="terms_performance_fee"></show-error>

                                              <label style="padding-top:30px;">Describe subscription and redemption terms.</label>
                                              <autosize-textarea placeholder="" v-model="questionaireForm.terms_subscription" rows="2" name="terms_subscription"></autosize-textarea>
                                              <show-error :form-name="questionaireForm" prop-name="terms_subscription"></show-error>
                                            </div>

                                          </div>
                                        </div>
                                    <!--    <button type="submit" class="btn btn-info waves-effect waves-light m-t-10 pull-right">{{trans('general.save')}}</button> -->





                                        <div style="padding-top:50px;">
                                          <h3 style="padding-top:30px;">TEAM MEMBERS:</h3>
                                          <label>Please insert the name of the first team member</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.team_member_1_name" style="margin-bottom:0;" />
                                          <label style="padding-top:10px;">Please insert the job title of the first team member</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.team_member_1_jobtitle" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="team_member_1_jobtitle"></show-error>
                                          <label style="padding-top:10px;">Can you describe this person’s main responsibilities?

                                          </label>
                                          <div class="pta-form-text-ai" style="position:relative">
                                            <autosize-textarea placeholder="" v-model="questionaireForm.team_member_1_responsibilities" rows="2" name="team_member_1_responsibilities"></autosize-textarea>

                                          </div>
                                          <show-error :form-name="questionaireForm" prop-name="team_member_1_responsibilities"></show-error>

                                          <label style="padding-top:30px;">Please insert the name of the second team member</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.team_member_2_name" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="team_member_2_name"></show-error>
                                          <label style="padding-top:10px;">Please insert the job title of the second team member</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.team_member_2_jobtitle" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="team_member_2_jobtitle"></show-error>
                                          <label style="padding-top:10px;">Can you describe this person’s main responsibilities?

                                          </label>
                                          <div class="pta-form-text-ai" style="position:relative">
                                            <autosize-textarea placeholder="" v-model="questionaireForm.team_member_2_responsibilities" rows="2" name="team_member_2_responsibilities"></autosize-textarea>

                                          </div>
                                          <show-error :form-name="questionaireForm" prop-name="team_member_2_responsibilities"></show-error>

                                          <label style="padding-top:30px;">Please insert the name of the third team member</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.team_member_3_name" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="team_member_3_name"></show-error>
                                          <label style="padding-top:10px;">Please insert the job title of the third team member</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.team_member_3_jobtitle" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="team_member_3_jobtitle"></show-error>
                                          <label style="padding-top:10px;">Can you describe this person’s main responsibilities?

                                          </label>
                                          <div class="pta-form-text-ai" style="position:relative">
                                            <autosize-textarea placeholder="" v-model="questionaireForm.team_member_3_responsibilities" rows="2" name="team_member_3_responsibilities"></autosize-textarea>

                                          </div>

                                          <show-error :form-name="questionaireForm" prop-name="team_member_3_responsibilities"></show-error>
                                        </div>

                                      </div>
                                      <div class="pta-steps" style="margin-bottom:30px;">
                                        <h3>INVESTOR-RELATED QUESTIONS:</h3>
                                        <label>From which investor do you want to raise capital from in the future (high level)?</label>
                                        <ul style="margin-bottom:0;">
                                          <li><input type="checkbox" id="c1" name="c1" value="1" v-model="questionaireForm.investor_types" :true-value="[]" /><label for="c1">High-net-worth investor</label></li>
                                          <li><input type="checkbox" id="c2" name="c2" value="2" v-model="questionaireForm.investor_types" :true-value="[]" /><label for="c2">Family Offices</label></li>
                                          <li><input type="checkbox" id="c3" name="c3" value="3" v-model="questionaireForm.investor_types" :true-value="[]" /><label for="c3">Institutional Investor</label></li>
                                        </ul>
                                        <show-error :form-name="questionaireForm" prop-name="investor_types"></show-error>
                                        <label style="padding-top:20px;">From which main country should your ideal investor come from?</label>
                                        <v-select label="name" track-by="id" v-model="selected_main_countries" name="main_country_id" id="main_country_id" :options="countries" :placeholder="'Please choose'" @select="onMainCountrySelect" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @remove="onMainCountryRemove" :selected="selected_main_countries"></v-select>
                                        <show-error :form-name="questionaireForm" prop-name="main_country_id"></show-error>
                                      </div>
                                      <div class="pta-steps">

                                        <div>
                                          <h3 style="padding-top:30px;">CASE STUDIES:</h3>
                                          <label>Please insert project name of sample investment 1.</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_1_project_name" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_1_project_name"></show-error>
                                          <label style="padding-top:10px;">How much was invested?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_1_amount_invested" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_1_amount_invested"></show-error>
                                          <label style="padding-top:10px;">What gross return did you achieve (IRR %)?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_1_irr" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_1_irr"></show-error>
                                          <label style="padding-top:10px;">What gross return did you achieve (Equity Multiple / MOIC (x))?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_1_moic" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_1_moic"></show-error>
                                          <label style="padding-top:10px;">Please insert summary of sample investment 1.</label>
                                          <autosize-textarea placeholder="" v-model="questionaireForm.case_study_1_summary" rows="2" name="case_study_1_summary"></autosize-textarea>
                                          <show-error :form-name="questionaireForm" prop-name="case_study_1_summary"></show-error>

                                          <label style="padding-top:30px;">Please insert project name of sample investment 2.</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_2_project_name" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_2_project_name"></show-error>
                                          <label style="padding-top:10px;">How much was invested?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_2_amount_invested" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_2_amount_invested"></show-error>
                                          <label style="padding-top:10px;">What gross return did you achieve (IRR %)?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_2_irr" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_2_irr"></show-error>
                                          <label style="padding-top:10px;">What gross return did you achieve (Equity Multiple / MOIC (x))?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_2_moic" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_2_moic"></show-error>
                                          <label style="padding-top:10px;">Please insert summary of sample investment 2.</label>
                                          <autosize-textarea placeholder="" v-model="questionaireForm.case_study_2_summary" rows="2" name="case_study_2_summary"></autosize-textarea>
                                          <show-error :form-name="questionaireForm" prop-name="case_study_2_summary"></show-error>

                                          <label style="padding-top:30px;">Please insert project name of sample investment 3.</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_3_project_name" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_3_project_name"></show-error>
                                          <label style="padding-top:10px;">How much was invested?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_3_amount_invested" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_3_amount_invested"></show-error>
                                          <label style="padding-top:10px;">What gross return did you achieve (IRR %)?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_3_irr" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_3_irr"></show-error>
                                          <label style="padding-top:10px;">What gross return did you achieve (Equity Multiple / MOIC (x))?</label>
                                          <input type="text" class="pta-form-text" v-model="questionaireForm.case_study_3_moic" style="margin-bottom:0;" />
                                          <show-error :form-name="questionaireForm" prop-name="case_study_3_moic"></show-error>
                                          <label style="padding-top:10px;">Please insert summary of sample investment 3.</label>
                                          <autosize-textarea placeholder="" v-model="questionaireForm.case_study_3_summary" rows="2" name="case_study_3_summary"></autosize-textarea>
                                          <show-error :form-name="questionaireForm" prop-name="case_study_3_summary"></show-error>
                                        </div>
                                      </div>

                                      <div class="pta-steps">
                                        <h3 style="padding-top:30px;">FUND ADMIN PROFILE:</h3>
                                        <label>What fund administration services are you in need of?</label>
                                        <ul style="margin-bottom:10px;">
                                          <li><input type="checkbox" id="fu1_1" name="fu1" value="1" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_1">Accounting & Fund Bookkeeping<span style="display:block;font-size:0.875em;line-height:1.5em;">Accounting (preparation of the financial statements), bookkeeping and payment services. Calculating and making capital and income distributions.</span></label></li>
                                          <li><input type="checkbox" id="fu1_2" name="fu1" value="2" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_2">AIFM Services<span style="display:block;font-size:0.875em;line-height:1.5em;">Risk management, Portfolio management (including Investment Committee if required), Governance, through the oversight of delegated activity and investor reporting.</span></label></li>
                                          <li><input type="checkbox" id="fu1_3" name="fu1" value="3" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_3">Company Secretarial<span style="display:block;font-size:0.875em;line-height:1.5em;">Corporate governance, effective administration and compliance.</span></label></li>
                                          <li><input type="checkbox" id="fu1_4" name="fu1" value="4" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_4">Depositary Services<span style="display:block;font-size:0.875em;line-height:1.5em;">Cash flow monitoring, safe keeping and record keeping of assets, Oversight & supervision of delegates and service providers of the Fund, Annual inventory of assets and audit confirmations</span></label></li>
                                          <li><input type="checkbox" id="fu1_5" name="fu1" value="5" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_5">Vehicle and Legal Entities Incorporation<span style="display:block;font-size:0.875em;line-height:1.5em;">Review of documentation and assistance with the implementation of the Fund structure</span></label></li>
                                          <li><input type="checkbox" id="fu1_6" name="fu1" value="6" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_6">Directorships<span style="display:block;font-size:0.875em;line-height:1.5em;">Appointment of experienced Directors, board meetings attendance, financial statement review.</span></label></li>
                                          <li><input type="checkbox" id="fu1_7" name="fu1" value="7" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_7">NAV Calculation<span style="display:block;font-size:0.875em;line-height:1.5em;">Periodic Net Asset Value Calculations</span></label></li>
                                          <li><input type="checkbox" id="fu1_8" name="fu1" value="8" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_8">Transfer Agency<span style="display:block;font-size:0.875em;line-height:1.5em;">Transfer agency (no retail investors, only professional and/or institutional investors), Anti-Money Laundering / Know-Your-Customer on the shareholders. Processing transfers and redemptions.</span></label></li>
                                          <li><input type="checkbox" id="fu1_9" name="fu1" value="9" v-model="questionaireForm.fund_admin_1" :true-value="[]" /><label for="fu1_9">Vehicle and Legal Entities Incorporation<span style="display:block;font-size:0.875em;line-height:1.5em;">Review of documentation and assistance with the implementation of the Fund structure</span></label></li>
                                        </ul>

                                        <label style="padding-top:10px;">In which jurisdiction will the Structure be established?</label>
                                        <v-select label="name" track-by="id" name="fund_admin_2_id" id="fund_admin_2_id" v-model="selected_fund_admin_2" :options="jurisdictions" :placeholder="'Please choose'" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @select="onFundAdmin2Select" @remove="onFundAdmin2Remove" :selected="selected_fund_admin_2"></v-select>
                                        <input type="text" style="margin-top:10px;" placeholder="Other option" v-if="show_fund_admin_2_other" class="pta-form-text" v-model="questionaireForm.fund_admin_2_other" />
                                        <label style="padding-top:10px;">Could you specify the preferred structure for the vehicle?</label>
                                        <v-select label="name" track-by="id" name="fund_admin_3_id" id="fund_admin_3_id" v-model="selected_fund_admin_3" :options="vehicle_structures" :placeholder="'Please choose'" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @select="onFundAdmin3Select" @remove="onFundAdmin3Remove" :selected="selected_fund_admin_3"></v-select>
                                        <input type="text" style="margin-top:10px;" placeholder="Other option" v-if="show_fund_admin_3_other" class="pta-form-text" v-model="questionaireForm.fund_admin_3_other" />
                                        <label style="padding-top:10px;">When is the vehicle's expected launch date?</label>
                                        <VueCtkDateTimePicker v-model="questionaireForm.fund_admin_4" format="YYYY-MM-DD" :no-label="true" :no-header="false" formatted="DD.MM.YYYY" color="#20365F" :only-date="true" label="none" button-now-translation="today" />
                                        <label style="padding-top:10px;">How many closes do you expect?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_5" style="margin-bottom:10px;" @keypress="onlyNumber" />
                                        <label>What is the vehicle's term (In years)?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_6" style="margin-bottom:10px;" @keypress="onlyNumber" />
                                        <label>What extensions are allowed in the vehicle term (in years)?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_7" style="margin-bottom:10px;" @keypress="onlyNumber" />
                                        <label>Will the vehicle use leverage? </label>
                                        <ul style="margin-bottom:10px;">
                                          <li><input type="radio" id="fund_admin_8_yes" name="fund_admin_8" value="Yes" v-model="questionaireForm.fund_admin_8" /><label for="fund_admin_8_yes">Yes</label></li>
                                          <li><input type="radio" id="fund_admin_8_no" name="fund_admin_8" value="No" v-model="questionaireForm.fund_admin_8" /><label for="fund_admin_8_no">No</label></li>
                                        </ul>
                                        <label>What is the expected vehicle size?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_9" style="margin-bottom:10px;" @keypress="onlyNumber" />
                                        <label>What is the fund status?</label>
                                        <ul style="margin-bottom:10px;">
                                          <li><input type="radio" id="fund_admin_10_ce" name="fund_admin_10" value="Closed Ended" v-model="questionaireForm.fund_admin_10" /><label for="fund_admin_10_ce">Closed Ended</label></li>
                                          <li><input type="radio" id="fund_admin_10_oe" name="fund_admin_10" value="Open Ended" v-model="questionaireForm.fund_admin_10" /><label for="fund_admin_10_oe">Open Ended</label></li>
                                        </ul>
                                        <label>If open ended, please describe the liquidity provisions afforded to investors in the vehicle</label>
                                        <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_11" rows="2" name="fund_admin_11"></autosize-textarea>
                                        <label>Can you describe the basic investment strategy?</label>
                                        <autosize-textarea :style="'margin-bottom:30px;'" v-model="questionaireForm.fund_admin_12" rows="2" name="fund_admin_12"></autosize-textarea>



                                        <h3>INVESTMENTS:</h3>
                                        <label>On an annual basis, how many investments is this vehicle projected to undertake?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_13" style="margin-bottom:10px;" @keypress="onlyNumber" />
                                        <label>Provide details regarding the expected size range of individual investments (Ticket size).</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_14" style="margin-bottom:10px;" @keypress="onlyAmount" />
                                        <label>How long is the investment period (in years)?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_15" style="margin-bottom:10px;" @keypress="onlyNumber" />
                                        <label>How long is the liquidation period expected to last (in years)?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_16" style="margin-bottom:10px;" @keypress="onlyNumber" />
                                        <label>How will the investments be held?</label>
                                        <v-select name="fund_admin_17_id" id="fund_admin_17_id" v-model="questionaireForm.fund_admin_17" :options="investment_types" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                        <input type="text" style="margin-top:10px;" placeholder="Other option" v-if="questionaireForm.fund_admin_17=='Other'" class="pta-form-text" v-model="questionaireForm.fund_admin_17_other" />
                                        <label style="padding-top:10px;">Where will the investments be located?</label>
                                        <v-select label="name" track-by="id" name="fund_admin_18_id" id="fund_admin_18_id" v-model="selected_fund_admin_18" :options="countries" :placeholder="'Please choose'" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @select="onFundAdmin18Select" @remove="onFundAdmin18Remove" :selected="selected_fund_admin_18"></v-select>


                                        <h3 style="padding-top:30px;">SERVICES/REPORTING:</h3>
                                        <label>At what intervals do you need the Net Asset Value calculations to be performed?</label>
                                        <v-select name="fund_admin_19_id" id="fund_admin_19_id" v-model="questionaireForm.fund_admin_19" :options="periods" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                        <label style="padding-top:10px;">Could you provide a concise overview of your approach to valuation?</label>
                                        <v-select name="fund_admin_20_id" id="fund_admin_20_id" v-model="questionaireForm.fund_admin_20" :options="valuation_approaches" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                        <input type="text" style="margin-top:10px;" placeholder="Other option" v-if="questionaireForm.fund_admin_20=='Other'" class="pta-form-text" v-model="questionaireForm.fund_admin_20_other" />
                                        <label style="padding-top:10px;">At what intervals do you need the management accounts to be provided?</label>
                                        <v-select name="fund_admin_21_id" id="fund_admin_21_id" v-model="questionaireForm.fund_admin_21" :options="periods" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                        <label style="padding-top:10px;">How frequent will investor reporting be required?</label>
                                        <v-select name="fund_admin_22_id" id="fund_admin_22_id" v-model="questionaireForm.fund_admin_22" :options="periods" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                        <label style="padding-top:10px;">At what intervals do you require investor newsletters to be distributed?</label>
                                        <v-select name="fund_admin_23_id" id="fund_admin_23_id" v-model="questionaireForm.fund_admin_23" :options="periods" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                        <label style="padding-top:10px;">How frequent is statutory reporting and drafting audited financial statements required?</label>
                                        <v-select name="fund_admin_24_id" id="fund_admin_24_id" v-model="questionaireForm.fund_admin_24" :options="periods" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>
                                        <label style="padding-top:10px;">What accounting standard do you employ?</label>
                                        <v-select name="fund_admin_25_id" id="fund_admin_25_id" v-model="questionaireForm.fund_admin_25" :options="accounting_standards" :placeholder="'Please choose'" :multiple="false" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose"></v-select>

                                        <input type="text" style="margin-top:10px;" placeholder="Other option" v-if="questionaireForm.fund_admin_25=='Other'" class="pta-form-text" v-model="questionaireForm.fund_admin_25_other" />
                                        <label style="padding-top:10px;">Will the fund accounts be consolidated?</label>
                                        <ul style="margin-bottom:10px;">
                                          <li><input type="radio" id="fund_admin_26_yes" name="fund_admin_26" value="Yes" v-model="questionaireForm.fund_admin_26" /><label for="fund_admin_26_yes">Yes</label></li>
                                          <li><input type="radio" id="fund_admin_26_no" name="fund_admin_26" value="No" v-model="questionaireForm.fund_admin_26" /><label for="fund_admin_26_no">No</label></li>
                                        </ul>
                                        <label>Do you require assistance with regards to your obligations under FATCA/CRS?</label>
                                        <ul style="margin-bottom:10px;">
                                          <li><input type="radio" id="fund_admin_27_yes" name="fund_admin_27" value="Yes" v-model="questionaireForm.fund_admin_27" /><label for="fund_admin_27_yes">Yes</label></li>
                                          <li><input type="radio" id="fund_admin_27_no" name="fund_admin_27" value="No" v-model="questionaireForm.fund_admin_27" /><label for="fund_admin_27_no">No</label></li>
                                        </ul>
                                        <label>Do you require US Tax compliance solutions?</label>
                                        <ul style="margin-bottom:10px;">
                                          <li><input type="radio" id="fund_admin_28_yes" name="fund_admin_28" value="Yes" v-model="questionaireForm.fund_admin_28" /><label for="fund_admin_28_yes">Yes</label></li>
                                          <li><input type="radio" id="fund_admin_28_no" name="fund_admin_28" value="No" v-model="questionaireForm.fund_admin_28" /><label for="fund_admin_28_no">No</label></li>
                                        </ul>
                                        <label>Is there a need for services related to the generation of board meeting minutes?</label>
                                        <ul style="margin-bottom:30px;">
                                          <li><input type="radio" id="fund_admin_29_yes" name="fund_admin_29" value="Yes" v-model="questionaireForm.fund_admin_29" /><label for="fund_admin_29_yes">Yes</label></li>
                                          <li><input type="radio" id="fund_admin_29_no" name="fund_admin_29" value="No" v-model="questionaireForm.fund_admin_29" /><label for="fund_admin_29_no">No</label></li>
                                        </ul>
                                        <h3>INVESTORS:</h3>
                                        <label>Where do you expect investors to come from?</label>
                                        <v-select label="name" track-by="id" name="fund_admin_30_id" id="fund_admin_30_id" v-model="selected_fund_admin_30" :options="countries" :placeholder="'Please choose'" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @select="onFundAdmin30Select" @remove="onFundAdmin30Remove" :selected="selected_fund_admin_30"></v-select>
                                        <label style="padding-top:10px;">What type of investors will invest into the vehicle?</label>
                                        <v-select label="name" track-by="id" name="fund_admin_31_id" id="fund_admin_31_id" v-model="selected_fund_admin_31" :options="investor_types_options" :placeholder="'Please choose'" :multiple="true" :close-on-select="true" :clear-on-select="false" :hide-selected="true" placeholder="Please choose" selectLabel="choose" @select="onFundAdmin31Select" @remove="onFundAdmin31Remove" :selected="selected_fund_admin_31"></v-select>
                                        <label style="padding-top:10px;">How many investors do you expect this vehicle to have?</label>
                                        <input type="text" class="pta-form-text" v-model="questionaireForm.fund_admin_32" style="margin-bottom:30px;" @keypress="onlyNumber" />


                                        <h3>OTHER:</h3>
                                        <label>What is the name of the legal entity serving as the General Partner within this structure?</label>
                                        <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_33" rows="2" name="fund_admin_34"></autosize-textarea>
                                        <label>What is the name of the legal entity taking on the role of Management Company or Investment Advisor in this setup?</label>
                                        <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_34" rows="2" name="fund_admin_36"></autosize-textarea>
                                        <label>Could you kindly disclose the identity of your other service providers (legal advisors, tax, audit, banking, etc.)?</label>
                                        <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_35" rows="2" name="fund_admin_36"></autosize-textarea>


                                        <!--
                                                  <label>Could you specify the preferred structure for the vehicle? (For instance: Luxembourg RAIF SCSp/SA, SCA).</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_3" rows="2" name="fund_admin_3"></autosize-textarea>
                                                  <label>What is the vehicle's term? (Example: 10+1+1 years from the date of the first closing)</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_7" rows="2" name="fund_admin_7"></autosize-textarea>



                                                  <label>Kindly provide details regarding the nature of the investments and their expected size range.</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_14" rows="2" name="fund_admin_14"></autosize-textarea>
                                                  <label>How will the investments be held? (Example: HoldCo/PropCo structure, Luxembourg)</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_15" rows="2" name="fund_admin_15"></autosize-textarea>
                                                  <label style="padding-top:10px;">How long is the investment period?</label>
                                                  <autosize-textarea :style="'margin-bottom:30px;'" v-model="questionaireForm.fund_admin_17" rows="2" name="fund_admin_17"></autosize-textarea>


                                                  <label>At what intervals do you need the Net Asset Value calculations to be performed? (For instance: Monthly)</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_18" rows="2" name="fund_admin_18"></autosize-textarea>
                                                  <label>Could you provide a concise overview of your approach to valuation? Additionally, how regularly do you carry out this process?</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_19" rows="2" name="fund_admin_19"></autosize-textarea>
                                                  <label>At what intervals do you need the interim management accounts to be provided? (For instance: On a quarterly basis)</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_20" rows="2" name="fund_admin_20"></autosize-textarea>
                                                  <label>How frequent will investor reporting be required?</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_21" rows="2" name="fund_admin_21"></autosize-textarea>
                                                  <label>How frequent is statutory reporting and drafting audited financial statements required?</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_22" rows="2" name="fund_admin_22"></autosize-textarea>
                                                  <label>Will the fund accaounts be consolidated?</label>
                                                  <ul style="margin-bottom:30px;">
                                                    <li><input type="radio" id="fund_admin_23_yes" name="fund_admin_23" value="Yes" v-model="questionaireForm.fund_admin_23" /><label for="fund_admin_23_yes">Yes</label></li>
                                                    <li><input type="radio" id="fund_admin_23_no" name="fund_admin_23" value="No" v-model="questionaireForm.fund_admin_23" /><label for="fund_admin_23_no">No</label></li>
                                                  </ul>



                                                  <label>Which entity will be taking on the role of Management Company or Investment Advisor in this setup?</label>
                                                  <autosize-textarea :style="'margin-bottom:10px;'" v-model="questionaireForm.fund_admin_25" rows="2" name="fund_admin_25"></autosize-textarea>


                                                  <label>Is there a need for services related to the generation of board meeting minutes?</label>
                                                  <ul style="margin-bottom:0;">
                                                    <li><input type="radio" id="fund_admin_28_yes" name="fund_admin_28" value="Yes" v-model="questionaireForm.fund_admin_28" /><label for="fund_admin_28_yes">Yes</label></li>
                                                    <li><input type="radio" id="fund_admin_28_no" name="fund_admin_28" value="No" v-model="questionaireForm.fund_admin_28" /><label for="fund_admin_28_no">No</label></li>
                                                  </ul>-->
                                      </div>

                                     <button type="submit" class="btn btn-info waves-effect waves-light m-t-10 pull-right">{{trans('general.save')}}</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <user-summary :user="user"></user-summary>
            </div>
        </div>

      <div id="modalApiResults" class="modal fade">
        <div class="modal-dialog" style="max-width:920px;">
          <div class="modal-content">
            <div class="modal-header" style="display:block;">
              <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
              <h4 id="modalTitle" class="modal-title">API Results</h4>
            </div>
            <div id="modalBody" class="modal-body" style="font-size:18px;line-height:24px;">
              <div class="row">
                <div v-if="!api_results && !api_error">Please wait ...</div>
                <div v-if="api_results">
                  <strong>Company Description</strong><br />
                  <span v-html="api_results.CompanyDescription"></span><br /><br />
                  <strong>Investment Strategy</strong><br />
                  <span v-html="api_results.InvestmentStrategy"></span><br /><br />
                  <strong>Track Record Highlights</strong><br />
                  <span v-html="api_results.TrackRecordHighlights"></span><br /><br />
                  <strong>Investment Thesis</strong><br />
                  <span v-html="api_results.InvestmentThesis"></span><br /><br />
                  <strong>SubSectors</strong><br />
                  <span v-html="api_results.SubSectors"></span><br /><br />
                  <strong>Investment Criteria</strong><br />
                  <span v-html="api_results.InvestmentCriteria"></span><br /><br />
                  <strong>Proceeds Distribution Policy</strong><br />
                  <span v-html="api_results.ProceedsDistributionPolicy"></span><br /><br />
                  <strong>Lockup Periods</strong><br />
                  <span v-html="api_results.LockupPeriods"></span><br /><br />
                  <strong>Subscription Terms</strong><br />
                  <span v-html="api_results.SubscriptionTerms"></span><br /><br />
                  <strong>Team Member 1 Responsibilities</strong><br />
                  <span v-html="api_results.TeamMember1Responsibilities"></span><br /><br />
                  <strong>Team Member 2 Responsibilities</strong><br />
                  <span v-html="api_results.TeamMember2Responsibilities"></span><br /><br />
                  <strong>Team Member 3 Responsibilities</strong><br />
                  <span v-html="api_results.TeamMember3Responsibilities"></span><br /><br />
                  <strong>Sample Investment 1 Summary</strong><br />
                  <span v-html="api_results.SampleInvestment1Summary"></span><br /><br />
                  <strong>Sample Investment 2 Summary</strong><br />
                  <span v-html="api_results.SampleInvestment2Summary"></span><br /><br />
                  <strong>Sample Investment 3 Summary</strong><br />
                  <span v-html="api_results.SampleInvestment3Summary"></span>
                </div>
                <div v-else-if="api_error" v-text="api_error">

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>

    </div>
</template>


<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import vSelect from 'vue-multiselect'
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import autosizeTextarea from '../../components/autosize-textarea'

    export default {
        components : { userSidebar,userSummary,vSelect, VueCtkDateTimePicker, autosizeTextarea },
        data() {
            return {
              id:this.$route.params.id,
              countries_cur : '',
              countries_2_cur : '',
              fund_types_cur : '',
              fund_categories : '',
              show_fund_admin_2_other : false,
              show_fund_admin_3_other : false,
              fund_types : '',
              continents: '',
              countries: [],
              currencies: [],
              selected_hq_countries: [],
              // selected_iv_countries: [],
              selected_asset_countries: [],
              selected_main_countries: [],
              selected_fund_admin_2: [],
              selected_fund_admin_3: [],
              selected_fund_admin_18: [],
              selected_fund_admin_30: [],
              selected_fund_admin_31: [],
              main_country_id: [],
              hq_country_id: [],
              iv_country_id: '',
              fund_admin_2_id: [],
              fund_admin_3_id: [],
              fund_admin_18_id: [],
              fund_admin_30_id: [],
              fund_admin_31_id: [],
              iv_country_id_temp: '',
              currency_id: '',
              currency_id_temp: '',
              asset_country_id: [],
              /* currency_id: [], */
              is_loading: false,
              api_results: '',
              api_error: '',
              questionaireApiForm: new Form(
                  {
                    FirstName: '',
                    LastName: '',
                    Email: '',
                    CompanyName: '',
                    WorkPhoneNumber: '',
                    Headquarters: '',
                    InvestorTarget: '',
                    InvestorCountry: '',
                    AssetClass: '',
                    PrimaryInvestmentLocation: '',
                    Currency: '',
                    HoldingPeriod: '',
                    ESGMembership: '',
                    InvestmentStructure: '',
                    CapitalRaisingTarget: '',
                    TargetIRR: '',
                    TargetEquityMultiple: '',
                    MinInvestmentTicketSize: '',
                    FundStatus: '',
                    FirstTimeFund: '',
                    FirstCloseTiming: '',
                    FinalCloseTiming: '',
                    ProductName: '',
                    ManagementFee: '',
                    CarriedInterest: '',
                    TeamMember1Name: '',
                    TeamMember1JobTitle: '',
                    TeamMember2Name: '',
                    TeamMember2JobTitle: '',
                    TeamMember3Name: '',
                    TeamMember3JobTitle: '',
                    SampleInvestment1Name: '',
                    SampleInvestment1Amount: '',
                    SampleInvestment1IRR: '',
                    SampleInvestment1MOIC: '',
                    SampleInvestment2Name: '',
                    SampleInvestment2Amount: '',
                    SampleInvestment2IRR: '',
                    SampleInvestment2MOIC: '',
                    SampleInvestment3Name: '',
                    SampleInvestment3Amount: '',
                    SampleInvestment3IRR: '',
                    SampleInvestment3MOIC: '',
                  },false
              ),
              questionaireForm: new Form({
                user_id: '',
                company: '',
                company_description: '',
                phone: '',
                hq_country_id: [],
                investor_types: [],
                main_country_id: [],
                fund_category_id: '',
                fund_type_id: '',
                asset_country_id: [],
                iv_country_id: '',
                currency_id: '',
                holding_period: 0,
                esg: '',
                inv_struct: '',
                total_capital: '',
                irr: '',
                moic: '',
                ticket_size: '',
                product_name: '',
                strategy: '',
                fund_status: '',
                fund_first_time: '',
                fund_first_close: '',
                fund_final_close: '',
                track_record_1: '',
                track_record_2: '',
                track_record_3: '',
                track_record_4: '',
                fund_admin_1: [],
                fund_admin_2: [],
                fund_admin_2_other: '',
                fund_admin_3: [],
                fund_admin_3_other: '',
                fund_admin_4: '',
                fund_admin_5: '',
                fund_admin_6: '',
                fund_admin_7: '',
                fund_admin_8: '',
                fund_admin_9: '',
                fund_admin_10: '',
                fund_admin_11: '',
                fund_admin_12: '',
                fund_admin_13: '',
                fund_admin_14: '',
                fund_admin_15: '',
                fund_admin_16: '',
                fund_admin_17: '',
                fund_admin_18_other: '',
                fund_admin_18: [],
                fund_admin_19: '',
                fund_admin_20: '',
                fund_admin_20_other: '',
                fund_admin_21: '',
                fund_admin_22: '',
                fund_admin_23: '',
                fund_admin_24: '',
                fund_admin_25: '',
                fund_admin_25_other: '',
                fund_admin_26: '',
                fund_admin_27: '',
                fund_admin_28: '',
                fund_admin_29: '',
                fund_admin_30: [],
                fund_admin_31: [],
                fund_admin_32: '',
                fund_admin_33: '',
                fund_admin_34: '',
                fund_admin_35: '',
                team_member_1_name: '',
                team_member_1_jobtitle: '',
                team_member_1_responsibilities: '',
                team_member_1_responsibilities_ai: '',
                team_member_2_name: '',
                team_member_2_jobtitle: '',
                team_member_2_responsibilities: '',
                team_member_2_responsibilities_ai: '',
                team_member_3_name: '',
                team_member_3_jobtitle: '',
                team_member_3_responsibilities: '',
                team_member_3_responsibilities_ai: '',
                investment_thesis: '',
                investment_focus_subsectors: '',
                investment_criteria: '',
                terms_policies: '',
                terms_lockup_period: '',
                terms_management_fee: '',
                terms_performance_fee: '',
                terms_subscription: '',
                case_study_1_project_name: '',
                case_study_1_amount_invested: '',
                case_study_1_irr: '',
                case_study_1_moic: '',
                case_study_1_summary: '',
                case_study_2_project_name: '',
                case_study_2_amount_invested: '',
                case_study_2_irr: '',
                case_study_2_moic: '',
                case_study_2_summary: '',
                case_study_3_project_name: '',
                case_study_3_amount_invested: '',
                case_study_3_irr: '',
                case_study_3_moic: '',
                case_study_3_summary: '',
                step: 1,
                is_premium: 0
              },false),

              vehicle_structures: [
                { id: 1, name: 'Common Investment Fund (CIF)' },
                { id: 2, name: 'Investment Trust' },
                { id: 3, name: 'Limited Liability Company (LLC)' },
                { id: 4, name: 'Limited Partnership (LP)' },
                { id: 5, name: 'Open Ended Investment Company (OEIC)' },
                { id: 6, name: 'Unit Trust' },
                { id: 7, name: 'I don\'t know' },
                { id: 8, name: 'Other' },
              ],
              jurisdictions: [
                { id: 1, name: 'Bermuda' },
                { id: 2, name: 'British Virgin Islands' },
                { id: 3, name: 'Cayman Islands' },
                { id: 4, name: 'Delaware' },
                { id: 5, name: 'Guernsey' },
                { id: 6, name: 'Ireland' },
                { id: 7, name: 'Jersey' },
                { id: 8, name: 'Luxembourg' },
                { id: 9, name: 'Malta' },
                { id: 10, name: 'Other' },
              ],
              investment_types: ['HoldCo','PropCo','Other'],
              valuation_approaches: ['Asian Valuation Standards (AVS)','Business Valuation Standards (BVS)','European Valuation Standards (EVS)','International Private Equity and Venture Capital Valuation (IPEV) Guidelines','International Valuation Standards (IVS)','Uniform Standards of Professional Appraisal Practice (USPAP)','Other'],
              accounting_standards: ['GAAP','International Financial Reporting Standards (IFRS)','Other'],
              periods: ['Weekly','Monthly','Quarterly','Semi-annually','Annually'],
              /*
              investment_types: [
                { id: 1, name: 'HoldCo' },
                { id: 2, name: 'PropCo' },
                { id: 3, name: 'Other' }
              ],
              valuation_approaches: [
                { id: 1, name: 'Asian Valuation Standards (AVS)' },
                { id: 2, name: 'Business Valuation Standards (BVS)' },
                { id: 3, name: 'European Valuation Standards (EVS)' },
                { id: 4, name: 'International Private Equity and Venture Capital Valuation (IPEV) Guidelines' },
                { id: 5, name: 'International Valuation Standards (IVS)' },
                { id: 6, name: 'Uniform Standards of Professional Appraisal Practice (USPAP)' },
                { id: 7, name: 'Other' }
              ],
              accounting_standards: [
                { id: 1, name: 'GAAP' },
                { id: 2, name: 'International Financial Reporting Standards (IFRS)' },
                { id: 3, name: 'Other' }
              ],
              periods: [
                { id: 1, name: 'Weekly' },
                { id: 2, name: 'Monthly' },
                { id: 3, name: 'Quarterly' },
                { id: 4, name: 'Semi-annually' },
                { id: 5, name: 'Annually' },
              ], */
              investor_types_options: [
                /* { id: 1, name: 'Investor Type List' }, */
                { id: 2, name: 'Family Office (Single)' },
                { id: 3, name: 'Family Office (Multi)' },
                { id: 4, name: 'Banking Institution' },
                { id: 5, name: 'Corporate Pension' },
                { id: 6, name: 'Corporation' },
                { id: 7, name: 'Direct Investment' },
                { id: 8, name: 'Discretionary Advisor' },
                { id: 9, name: 'Economic Development Agency' },
                { id: 10, name: 'Endowment' },
                { id: 11, name: 'Foundation' },
                { id: 12, name: 'Fund of Funds' },
                { id: 13, name: 'Government Agency' },
                { id: 14, name: 'Insurance Company' },
                { id: 15, name: 'Investment Advisor' },
                { id: 16, name: 'Money Management Firm' },
                { id: 17, name: 'Mutual Fund Company' },
                { id: 18, name: 'Other Limited Partner' },
                { id: 19, name: 'Private Investment Fund' },
                { id: 20, name: 'Public Pension Fund' },
                { id: 21, name: 'Real Estate Investment Company' },
                { id: 22, name: 'Secondary LP' },
                { id: 23, name: 'Sovereign Wealth Fund' },
                { id: 24, name: 'Union Pension Fund' },
                { id: 25, name: 'University (Non-Endowment)' },
                { id: 26, name: 'Wealth Management Firm' },
                { id: 27, name: 'High-net-worth Investor' },
                { id: 28, name: 'Institutional Investor' },
              ],

              step: 1,
              is_premium: 0,
              is_send: false,
              questionnaire_step: 0,
              user: '',
              userForm: new Form({
                phone: '',
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zipcode: '',
                country_id: ''
              },false),
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

          axios.get('/api/user/'+this.id)
              .then(response => response.data)
              .then(response => {
                this.user = response.user;
                this.userForm.phone = response.user.profile.phone;
                this.userForm.address_line_1 = response.user.profile.address_line_1;
                this.userForm.address_line_2 = response.user.profile.address_line_2;
                this.userForm.city = response.user.profile.city;
                this.userForm.state = response.user.profile.state;
                this.userForm.zipcode = response.user.profile.zipcode;
                this.userForm.country_id = response.user.profile.country_id || '';
              })
              .catch(error => {
                helper.showDataErrorMsg(error);
                this.$router.push('/user/general-partners');
              })

          this.prerequisite();

        },
        methods: {
          prerequisite(){
            axios.get('/api/user/profile/questionnaire/pre-requisite')
                .then(response => response.data)
                .then(response => {
                  this.fund_categories  = response.fund_categories;
                  this.fund_types       = response.fund_types;
                  this.continents       = response.continents;
                  this.countries        = response.countries;
                  this.currencies        = response.currencies;
                  this.getQuestionnaire();
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          onMainCountrySelect(selectedOption){
            this.questionaireForm.errors.clear('main_country_id');
            this.main_country_id.push(selectedOption.id);
          },
          onMainCountryRemove(removedOption){
            this.main_country_id.splice(this.main_country_id.indexOf(removedOption.id), 1);
          },
          onHQCountrySelect(selectedOption){
            this.questionaireForm.errors.clear('hq_country_id');
            this.hq_country_id.push(selectedOption.id);
          },
          onHQCountryRemove(removedOption){
            this.hq_country_id.splice(this.hq_country_id.indexOf(removedOption.id), 1);
          },
          onAssetCountrySelect(selectedOption){
            this.questionaireForm.errors.clear('asset_country_id');
            this.asset_country_id.push(selectedOption.id);
          },
          onAssetCountryRemove(removedOption){
            this.asset_country_id.splice(this.asset_country_id.indexOf(removedOption.id), 1);
          },
          onFundAdmin2Select(selectedOption){
            this.questionaireForm.errors.clear('fund_admin_2');
            this.fund_admin_2_id.push(selectedOption.id);
            this.checkFundAdmin2Other();
          },
          onFundAdmin2Remove(removedOption){
            this.fund_admin_2_id.splice(this.fund_admin_2_id.indexOf(removedOption.id), 1);
            this.checkFundAdmin2Other();
          },
          checkFundAdmin2Other(){
            this.show_fund_admin_2_other = false;
            this.selected_fund_admin_2.forEach(function (item) {
              if(item.id===10){
                this.show_fund_admin_2_other = true;
              }
            }.bind(this));
          },
          onFundAdmin3Select(selectedOption){
            this.questionaireForm.errors.clear('fund_admin_3');
            this.fund_admin_3_id.push(selectedOption.id);
            this.checkFundAdmin3Other();
          },
          onFundAdmin3Remove(removedOption){
            this.fund_admin_3_id.splice(this.fund_admin_3_id.indexOf(removedOption.id), 1);
            this.checkFundAdmin3Other();
          },
          checkFundAdmin3Other(){
            this.show_fund_admin_3_other = false;
            this.selected_fund_admin_3.forEach(function (item) {
              if(item.id===8){
                this.show_fund_admin_3_other = true;
              }
            }.bind(this));
          },
          onFundAdmin18Select(selectedOption){
            this.questionaireForm.errors.clear('fund_admin_18');
            this.fund_admin_18_id.push(selectedOption.id);
          },
          onFundAdmin18Remove(removedOption){
            this.fund_admin_18_id.splice(this.fund_admin_18_id.indexOf(removedOption.id), 1);
          },

          onFundAdmin30Select(selectedOption){
            this.questionaireForm.errors.clear('fund_admin_30');
            this.fund_admin_30_id.push(selectedOption.id);
          },
          onFundAdmin30Remove(removedOption){
            this.fund_admin_30_id.splice(this.fund_admin_30_id.indexOf(removedOption.id), 1);
          },

          onFundAdmin31Select(selectedOption){
            this.questionaireForm.errors.clear('fund_admin_31');
            this.fund_admin_31_id.push(selectedOption.id);
          },
          onFundAdmin31Remove(removedOption){
            this.fund_admin_31_id.splice(this.fund_admin_31_id.indexOf(removedOption.id), 1);
          },
          goNext(){
            if(!this.is_send) {
              this.is_send = true;
              this.selected_hq_countries.forEach(function (item) {
                this.questionaireForm.hq_country_id.push(item.id);
              }.bind(this));

              this.selected_main_countries.forEach(function (item) {
                this.questionaireForm.main_country_id.push(item.id);
              }.bind(this));

              this.selected_asset_countries.forEach(function (item) {
                this.questionaireForm.asset_country_id.push(item.id);
              }.bind(this));

              this.selected_fund_admin_2.forEach(function (item) {
                this.questionaireForm.fund_admin_2.push(item.id);
              }.bind(this));
              this.selected_fund_admin_3.forEach(function (item) {
                this.questionaireForm.fund_admin_3.push(item.id);
              }.bind(this));
              this.selected_fund_admin_18.forEach(function (item) {
                this.questionaireForm.fund_admin_18.push(item.id);
              }.bind(this));
              this.selected_fund_admin_30.forEach(function (item) {
                this.questionaireForm.fund_admin_30.push(item.id);
              }.bind(this));
              this.selected_fund_admin_31.forEach(function (item) {
                this.questionaireForm.fund_admin_31.push(item.id);
              }.bind(this));

              this.questionaireForm.currency_id = this.currency_id.id;
              this.questionaireForm.iv_country_id = this.iv_country_id.id;
              this.questionaireForm.step = this.step;
              this.questionaireForm.is_premium = this.is_premium;
              this.questionaireForm.post('/api/user/profile/questionnaire')
                  .then(response => {
                    toastr.success(response.message);
                    this.step = this.step + 1;
                    this.questionaireForm.hq_country_id = [];
                    this.questionaireForm.main_country_id = [];
                    this.questionaireForm.asset_country_id = [];
                    this.questionaireForm.fund_admin_2 = [];
                    this.questionaireForm.fund_admin_3 = [];
                    this.questionaireForm.fund_admin_18 = [];
                    this.questionaireForm.fund_admin_30 = [];
                    this.questionaireForm.fund_admin_31 = [];
                    this.questionaireForm.iv_country_id = '';
                    this.questionaireForm.currency_id = '';
                    this.is_send = false;
                    this.questionnaire_step = response.questionnaire_step;
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                    this.is_send = false;
                  });

            }
          },

          submit(){
            if(!this.is_send) {
              this.is_send = true;
              this.selected_hq_countries.forEach(function (item) {
                this.questionaireForm.hq_country_id.push(item.id);
              }.bind(this));

              this.selected_main_countries.forEach(function (item) {
                this.questionaireForm.main_country_id.push(item.id);
              }.bind(this));

              this.selected_asset_countries.forEach(function (item) {
                this.questionaireForm.asset_country_id.push(item.id);
              }.bind(this));

              this.selected_fund_admin_2.forEach(function (item) {
                this.questionaireForm.fund_admin_2.push(item.id);
              }.bind(this));
              this.selected_fund_admin_3.forEach(function (item) {
                this.questionaireForm.fund_admin_3.push(item.id);
              }.bind(this));
              this.selected_fund_admin_18.forEach(function (item) {
                this.questionaireForm.fund_admin_18.push(item.id);
              }.bind(this));
              this.selected_fund_admin_30.forEach(function (item) {
                this.questionaireForm.fund_admin_30.push(item.id);
              }.bind(this));
              this.selected_fund_admin_31.forEach(function (item) {
                this.questionaireForm.fund_admin_31.push(item.id);
              }.bind(this));

              this.questionaireForm.currency_id = this.currency_id.id;
              this.questionaireForm.iv_country_id = this.iv_country_id.id;
              this.questionaireForm.step = 4;
              this.questionaireForm.user_id = this.id;
              this.questionaireForm.is_premium = this.is_premium;
              this.questionaireForm.post('/api/user/profile/questionnaire')
                  .then(response => {
                    toastr.success(response.message);
                    this.is_send = false;
                    this.questionaireForm.hq_country_id = [];
                    this.questionaireForm.main_country_id = [];
                    this.questionaireForm.asset_country_id = [];
                    this.questionaireForm.iv_country_id = '';
                    this.questionaireForm.currency_id = '';
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                    this.is_send = false;
                  });

            }
          },
          getAIData(){

          /*  this.questionaireApiForm.FirstName = this.user.profile.first_name;
            this.questionaireApiForm.LastName = this.user.profile.last_name;
            this.questionaireApiForm.Email = this.user.email;
            this.questionaireApiForm.CompanyName = this.user.profile.company;
            this.questionaireApiForm.WorkPhoneNumber = this.user.profile.phone;
            this.questionaireApiForm.Headquarters = this.user.profile.hq_countries.map(obj => obj.name).join(',');
            this.questionaireApiForm.InvestorTarget = this.user.profile.asset_countries.map(obj => obj.name).join(',');
            this.questionaireApiForm.InvestorCountry = this.user.profile.main_countries.map(obj => obj.name).join(',');
            this.questionaireApiForm.AssetClass = this.user.profile.fund_type.name;
            this.questionaireApiForm.PrimaryInvestmentLocation = this.user.profile.main_countries.map(obj => obj.name).join(',');
            this.questionaireApiForm.Currency = "USD";
            this.questionaireApiForm.HoldingPeriod = this.user.profile.holding_period;
            this.questionaireApiForm.ESGMembership = this.user.profile.esg;
            this.questionaireApiForm.InvestmentStructure = this.user.profile.inv_struct;
            this.questionaireApiForm.CapitalRaisingTarget = this.user.profile.total_capital;
            this.questionaireApiForm.TargetIRR = this.user.profile.irr;
            this.questionaireApiForm.TargetEquityMultiple = this.user.profile.moic;
            this.questionaireApiForm.MinInvestmentTicketSize = this.user.profile.ticket_size;
            this.questionaireApiForm.FundStatus = this.user.profile.fund_status;
            this.questionaireApiForm.FirstTimeFund = this.user.profile.fund_first_time;
            this.questionaireApiForm.FirstCloseTiming = this.user.profile.fund_first_close;
            this.questionaireApiForm.FinalCloseTiming = this.user.profile.fund_final_close;
            this.questionaireApiForm.ProductName = this.user.profile.product_name;
            this.questionaireApiForm.ManagementFee = this.user.profile.terms_management_fee;
            this.questionaireApiForm.CarriedInterest = this.user.profile.terms_performance_fee;
            this.questionaireApiForm.TeamMember1Name = this.user.profile.team_member_1_name;
            this.questionaireApiForm.TeamMember1JobTitle = this.user.profile.team_member_1_jobtitle;
            this.questionaireApiForm.TeamMember2Name = this.user.profile.team_member_2_name;
            this.questionaireApiForm.TeamMember2JobTitle = this.user.profile.team_member_2_jobtitle;
            this.questionaireApiForm.TeamMember3Name = this.user.profile.team_member_3_name;
            this.questionaireApiForm.TeamMember3JobTitle = this.user.profile.team_member_3_jobtitle;
            this.questionaireApiForm.SampleInvestment1Name = this.user.profile.case_study_1_project_name;
            this.questionaireApiForm.SampleInvestment1Amount = this.user.profile.case_study_1_amount_invested;
            this.questionaireApiForm.SampleInvestment1IRR = this.user.profile.case_study_1_irr;
            this.questionaireApiForm.SampleInvestment1MOIC = this.user.profile.case_study_1_moic;
            this.questionaireApiForm.SampleInvestment2Name = this.user.profile.case_study_2_project_name;
            this.questionaireApiForm.SampleInvestment2Amount = this.user.profile.case_study_2_amount_invested;
            this.questionaireApiForm.SampleInvestment2IRR = this.user.profile.case_study_2_irr;
            this.questionaireApiForm.SampleInvestment2MOIC = this.user.profile.case_study_2_moic;
            this.questionaireApiForm.SampleInvestment3Name = this.user.profile.case_study_3_project_name;
            this.questionaireApiForm.SampleInvestment3Amount = this.user.profile.case_study_3_amount_invested;
            this.questionaireApiForm.SampleInvestment3IRR = this.user.profile.case_study_3_irr;
            this.questionaireApiForm.SampleInvestment3MOIC = this.user.profile.case_study_3_moic;

            this.questionaireApiForm.post('https://mnr1j9m4n0.execute-api.us-east-1.amazonaws.com/default/gpquestionnaire')
                .then(response => {

                })
                .catch(error => {
                  helper.showErrorMsg(error);
                }); */

            this.api_results = '';
            this.api_error = '';
            $('#modalApiResults').modal();

            axios.get('/api/user/'+this.id+'/api')
                .then(response => response.data)
                .then(response => {

                  if(response.error){
                    this.api_error = response.message;
                  }else{
                    this.api_results = response;
                  }

                })
                .catch(error => {
                  console.log("error");
                  if(error.response.data.errors.hasOwnProperty("message")) {
                    this.api_error = error.response.data.errors.message[0];
                  }
                  // helper.showDataErrorMsg(error);
                });


          },
          getFundTypes(){
            this.questionaireForm.fund_type_id = '';
            if(this.questionaireForm.fund_category_id){
              this.fund_categories.forEach(function(fund_category) {
                if(fund_category.id==this.questionaireForm.fund_category_id){
                  this.fund_types_cur = fund_category.fund_types;
                }
              }.bind(this));
            }
          },
          getQuestionnaire(){
            axios.get('/api/user/'+this.id+'/questionnaire')
                .then(response => response.data)
                .then(response => {
                  if(response.user.profile.hq_countries){
                    this.selected_hq_countries       = response.user.profile.hq_countries;
                  }else{
                    this.selected_hq_countries    = [];
                  }
                  if(response.user.profile.main_countries){
                    this.selected_main_countries    = response.user.profile.main_countries;
                  }else{
                    this.selected_main_countries    = [];
                  }

                  if(response.user.profile.asset_countries){
                    this.selected_asset_countries    = response.user.profile.asset_countries;
                  }else{
                    this.selected_asset_countries     = [];
                  }

                  if(response.user.profile.fund_category_id){
                    this.questionaireForm.fund_category_id  = response.user.profile.fund_category_id;
                    this.getFundTypes();
                  }else{
                    this.questionaireForm.fund_category_id     = '';
                  }

                  if(response.user.profile.fund_type_id){
                    this.questionaireForm.fund_type_id = response.user.profile.fund_type_id;
                  }else{
                    this.questionaireForm.fund_type_id = '';
                  }

                  this.questionaireForm.investor_types      = response.user.profile.investor_types;
                  if(response.user.profile.company == '') {
                    this.questionaireForm.investor_types = [];
                  }

                  if(response.user.profile.currency_id){
                    this.currency_id_temp = response.user.profile.currency_id;
                    this.currencies.forEach(function (item) {
                      if(this.currency_id_temp == item.id){
                        this.currency_id = item;
                        return;
                      }
                    }.bind(this));
                  }

                  if(response.user.profile.iv_country_id){
                    this.iv_country_id_temp = response.user.profile.iv_country_id;
                    this.countries.forEach(function (item) {
                      if(this.iv_country_id_temp == item.id){
                        this.iv_country_id = item;
                        return;
                      }
                    }.bind(this));
                  }

                  this.questionnaire_step =  response.user.profile.questionnaire_step;
                  this.questionaireForm.company             = response.user.profile.company;
                  this.questionaireForm.company_description             = response.user.profile.company_description;
                  this.questionaireForm.phone               = response.user.profile.phone;
                  this.questionaireForm.holding_period               = response.user.profile.holding_period;
                  this.questionaireForm.esg                   = response.user.profile.esg;
                  this.questionaireForm.inv_struct               = response.user.profile.inv_struct;
                  this.questionaireForm.total_capital               = response.user.profile.total_capital;
                  this.questionaireForm.irr                         = response.user.profile.irr;
                  this.questionaireForm.moic                        = response.user.profile.moic;
                  this.questionaireForm.ticket_size                 = response.user.profile.ticket_size;
                  this.questionaireForm.product_name                 = response.user.profile.product_name;
                  this.questionaireForm.strategy                    = response.user.profile.strategy;
                  this.questionaireForm.fund_status                 = response.user.profile.fund_status;
                  this.questionaireForm.fund_first_time             = response.user.profile.fund_first_time;
                  this.questionaireForm.fund_first_close            = response.user.profile.fund_first_close;
                  this.questionaireForm.fund_final_close            = response.user.profile.fund_final_close;
                  this.questionaireForm.track_record_1              = response.user.profile.track_record_1;
                  this.questionaireForm.track_record_2    = response.user.profile.track_record_2;
                  this.questionaireForm.track_record_3    = response.user.profile.track_record_3;
                  this.questionaireForm.track_record_4    = response.user.profile.track_record_4;

                  if(response.user.profile.fund_admin_2){
                    this.selected_fund_admin_2    = response.user.profile.fund_admin_2;
                  }else{
                    this.selected_fund_admin_2     = [];
                  }
                  if(response.user.profile.fund_admin_3){
                    this.selected_fund_admin_3    = response.user.profile.fund_admin_3;
                  }else{
                    this.selected_fund_admin_3     = [];
                  }
                  if(response.user.profile.fund_admin_18){
                    this.selected_fund_admin_18    = response.user.profile.fund_admin_18;
                  }else{
                    this.selected_fund_admin_18     = [];
                  }
                  if(response.user.profile.fund_admin_30){
                    this.selected_fund_admin_30    = response.user.profile.fund_admin_30;
                  }else{
                    this.selected_fund_admin_30     = [];
                  }
                  if(response.user.profile.fund_admin_31){
                    this.selected_fund_admin_31    = response.user.profile.fund_admin_31;
                  }else{
                    this.selected_fund_admin_31     = [];
                  }

                  if(response.user.profile.fund_admin_1){
                    this.questionaireForm.fund_admin_1 = response.user.profile.fund_admin_1;
                  }else{
                    this.questionaireForm.fund_admin_1 = [];
                  }

                  this.questionaireForm.fund_admin_2_other              = response.user.profile.fund_admin_2_other;
                  this.questionaireForm.fund_admin_3_other              = response.user.profile.fund_admin_3_other;
                  this.questionaireForm.fund_admin_4              = response.user.profile.fund_admin_4;
                  this.questionaireForm.fund_admin_5              = response.user.profile.fund_admin_5;
                  this.questionaireForm.fund_admin_6              = response.user.profile.fund_admin_6;
                  this.questionaireForm.fund_admin_7              = response.user.profile.fund_admin_7;
                  this.questionaireForm.fund_admin_8              = response.user.profile.fund_admin_8;
                  this.questionaireForm.fund_admin_9              = response.user.profile.fund_admin_9;
                  this.questionaireForm.fund_admin_10              = response.user.profile.fund_admin_10;
                  this.questionaireForm.fund_admin_11              = response.user.profile.fund_admin_11;
                  this.questionaireForm.fund_admin_12              = response.user.profile.fund_admin_12;
                  this.questionaireForm.fund_admin_13              = response.user.profile.fund_admin_13;
                  this.questionaireForm.fund_admin_14              = response.user.profile.fund_admin_14;
                  this.questionaireForm.fund_admin_15              = response.user.profile.fund_admin_15;
                  this.questionaireForm.fund_admin_16              = response.user.profile.fund_admin_16;
                  this.questionaireForm.fund_admin_17              = response.user.profile.fund_admin_17;
                  this.questionaireForm.fund_admin_17_other        = response.user.profile.fund_admin_17_other;
                  this.questionaireForm.fund_admin_19              = response.user.profile.fund_admin_19;
                  this.questionaireForm.fund_admin_20              = response.user.profile.fund_admin_20;
                  this.questionaireForm.fund_admin_20_other        = response.user.profile.fund_admin_20_other;
                  this.questionaireForm.fund_admin_21              = response.user.profile.fund_admin_21;
                  this.questionaireForm.fund_admin_22              = response.user.profile.fund_admin_22;
                  this.questionaireForm.fund_admin_23              = response.user.profile.fund_admin_23;
                  this.questionaireForm.fund_admin_24              = response.user.profile.fund_admin_24;
                  this.questionaireForm.fund_admin_25              = response.user.profile.fund_admin_25;
                  this.questionaireForm.fund_admin_25_other        = response.user.profile.fund_admin_25_other;
                  this.questionaireForm.fund_admin_26              = response.user.profile.fund_admin_26;
                  this.questionaireForm.fund_admin_27              = response.user.profile.fund_admin_27;
                  this.questionaireForm.fund_admin_28              = response.user.profile.fund_admin_28;
                  this.questionaireForm.fund_admin_29              = response.user.profile.fund_admin_29;
                  this.questionaireForm.fund_admin_32              = response.user.profile.fund_admin_32;
                  this.questionaireForm.fund_admin_33              = response.user.profile.fund_admin_33;
                  this.questionaireForm.fund_admin_34              = response.user.profile.fund_admin_34;
                  this.questionaireForm.fund_admin_35              = response.user.profile.fund_admin_35;

                  this.questionaireForm.team_member_1_name              = response.user.profile.team_member_1_name;
                  this.questionaireForm.team_member_1_jobtitle              = response.user.profile.team_member_1_jobtitle;
                  this.questionaireForm.team_member_1_responsibilities              = response.user.profile.team_member_1_responsibilities;
                  this.questionaireForm.team_member_1_responsibilities_ai              = response.user.profile.team_member_1_responsibilities_ai;
                  this.questionaireForm.team_member_2_name              = response.user.profile.team_member_2_name;
                  this.questionaireForm.team_member_2_jobtitle              = response.user.profile.team_member_2_jobtitle;
                  this.questionaireForm.team_member_2_responsibilities              = response.user.profile.team_member_2_responsibilities;
                  this.questionaireForm.team_member_2_responsibilities_ai              = response.user.profile.team_member_2_responsibilities_ai;
                  this.questionaireForm.team_member_3_name              = response.user.profile.team_member_3_name;
                  this.questionaireForm.team_member_3_jobtitle              = response.user.profile.team_member_3_jobtitle;
                  this.questionaireForm.team_member_3_responsibilities              = response.user.profile.team_member_3_responsibilities;
                  this.questionaireForm.team_member_3_responsibilities_ai              = response.user.profile.team_member_3_responsibilities_ai;
                  this.questionaireForm.investment_thesis              = response.user.profile.investment_thesis;
                  this.questionaireForm.investment_focus_subsectors              = response.user.profile.investment_focus_subsectors;
                  this.questionaireForm.investment_criteria              = response.user.profile.investment_criteria;
                  this.questionaireForm.terms_policies              = response.user.profile.terms_policies;
                  this.questionaireForm.terms_lockup_period              = response.user.profile.terms_lockup_period;
                  this.questionaireForm.terms_management_fee              = response.user.profile.terms_management_fee;
                  this.questionaireForm.terms_performance_fee              = response.user.profile.terms_performance_fee;
                  this.questionaireForm.terms_subscription              = response.user.profile.terms_subscription;
                  this.questionaireForm.case_study_1_project_name              = response.user.profile.case_study_1_project_name;
                  this.questionaireForm.case_study_1_amount_invested              = response.user.profile.case_study_1_amount_invested;
                  this.questionaireForm.case_study_1_irr              = response.user.profile.case_study_1_irr;
                  this.questionaireForm.case_study_1_moic              = response.user.profile.case_study_1_moic;
                  this.questionaireForm.case_study_1_summary              = response.user.profile.case_study_1_summary;
                  this.questionaireForm.case_study_2_project_name              = response.user.profile.case_study_2_project_name;
                  this.questionaireForm.case_study_2_amount_invested              = response.user.profile.case_study_2_amount_invested;
                  this.questionaireForm.case_study_2_irr              = response.user.profile.case_study_2_irr;
                  this.questionaireForm.case_study_2_moic              = response.user.profile.case_study_2_moic;
                  this.questionaireForm.case_study_2_summary              = response.user.profile.case_study_2_summary;
                  this.questionaireForm.case_study_3_project_name              = response.user.profile.case_study_3_project_name;
                  this.questionaireForm.case_study_3_amount_invested              = response.user.profile.case_study_3_amount_invested;
                  this.questionaireForm.case_study_3_irr              = response.user.profile.case_study_3_irr;
                  this.questionaireForm.case_study_3_moic              = response.user.profile.case_study_3_moic;
                  this.questionaireForm.case_study_3_summary              = response.user.profile.case_study_3_summary;


                  this.is_premium = response.user.profile.is_premium;
                  this.is_loading = false;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          onlyAmount ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode != 46 ) {
              $event.preventDefault();
            }
          },
          onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) {
              $event.preventDefault();
            }
          },
          filterInputPaste($event){
            return $event.preventDefault();
          },
          filterInputPhone($event){
            let keyValue = ($event.key ? $event.key : $event.which);
            if((isNaN(parseFloat(keyValue)) || !isFinite(keyValue)) && keyValue!="+" && keyValue!=" " && keyValue!=")" && keyValue!="(" && keyValue!="Delete" && keyValue!="Backspace" && keyValue!="ArrowLeft" && keyValue!="ArrowRight"){
              return $event.preventDefault();
            }
          },
        }
    }
</script>
